// RETRIEVE THE ENV VARIABLES
export const NOT_CONFIGURED = "not_configured";
export const ENV = sanitizeUrl(process.env.REACT_APP_ENV) || NOT_CONFIGURED;
export const BASE_URL =
    sanitizeUrl(process.env.REACT_APP_API_URL) || NOT_CONFIGURED;
export const WEB_SOCKET_URL =
    sanitizeUrl(process.env.REACT_APP_WEB_SOCKET_URL) || NOT_CONFIGURED;
export const GENESIS_PATH =
    sanitizeUrl(process.env.REACT_APP_GENESIS_URL) || NOT_CONFIGURED;
export const RECONNECT_INTERVAL = Number(
    process.env.REACT_APP_RECONNECT_INTERVAL || 5000
);

function sanitizeUrl(envVar: any) {
    let removedBackSlash: any = "";
    const checkBackSlash = envVar.trim().endsWith("/");
    if (checkBackSlash) {
        removedBackSlash = envVar.trim().slice(0, -1);
        return removedBackSlash;
    }
    return envVar.trim();
}

// FAIL-SAFE HANDLING
export type ConfigCheckResult = {
    ok: boolean;
    issues: string[];
};

export async function checkConfig(): Promise<ConfigCheckResult> {
    const issues: string[] = [];

    if (ENV === NOT_CONFIGURED) issues.push("ENV_NOT_CONFIGURED");
    if (BASE_URL === NOT_CONFIGURED) issues.push("BASE_URL_NOT_CONFIGURED");
    if (WEB_SOCKET_URL === NOT_CONFIGURED)
        issues.push("WEB_SOCKET_URL_NOT_CONFIGURED");
    if (GENESIS_PATH === NOT_CONFIGURED)
        issues.push("GENESIS_PATH_NOT_CONFIGURED");
    return {
        ok: issues.length === 0,
        issues
    };
}
